import axios from "axios";
import { tr } from "@/lib/i18n";

export const BASE = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !String(cfg.url).includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch {
        window.dispatchEvent(new Event("auth:logout"));
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!e?.response) return tr("تعذر الاتصال. تأكد من الإنترنت وحاول مرة أخرى");
  if (!d) return tr("حدث خطأ، حاول مرة أخرى");
  if (typeof d === "string") return tr(d);
  if (Array.isArray(d)) return tr("تأكد من تعبئة جميع الحقول المطلوبة بشكل صحيح");
  return String(d.msg || d);
}

export async function openFile(fileId) {
  const w = window.open("", "_blank");
  try {
    const { data } = await api.get(`/files/${fileId}/link`);
    if (w) w.location.href = BASE + data.url;
    else window.location.href = BASE + data.url;
  } catch (e) {
    if (w) w.close();
    throw e;
  }
}

export async function fileUrl(fileId) {
  const { data } = await api.get(`/files/${fileId}/link`);
  return BASE + data.url;
}

export async function fetchBlob(path) {
  const { data } = await api.get(path, { responseType: "blob" });
  return data;
}

export function saveBlob(blob, name) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}
